import { APIAdapter } from "../../../../helpers/api_helper";
import axios from "axios";
const api = new APIAdapter();

  export const addBusiness = async (data) => {
      try {
        const response = await api.create(`/developer-accounts/${data?.merchandId}`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getBusinessByMarchandId = async (merchandId) => {
      try {
        const response = await api.get(`/developer-accounts/merchant/${merchandId}`);
        return response;
      } catch (error) {
        throw error;
      }
  };
  
  export const getCompanyByMarchandId = async (merchandId) => {
      try {
        const response = await api.get(`/merchants/${merchandId}/companies`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getAllDevelopers = async () => {
      try {
        const response = await api.get(`/developer-account-sum/summary`)        
        return response;
      } catch (error) {
        throw error;
      }
  };
    export const getDeveloperById = async (developerId) => {
        try {
          const response = await api.get(`/developer-accounts/${developerId}`);
          return response;
        } catch (error) {
          throw error;
        }
    };
       export const getDeveloperBalanceById = async (developerId) => {
        try {
          const response = await api.get(`/admin/dashboard/balances/${developerId}`);
          return response;
        } catch (error) {
          throw error;
        }
    };
     export const getTransactionCartebyDeveloper = async (developerId) => {
        try {
          const response = await api.get(`/admin/scheduler/pending/details/${developerId}`);
          return response;
        } catch (error) {
          throw error;
        }
    };
    export const validateTransaction = async (id) => {
  try {
    const response = await axios.post(
      `/admin/scheduler/settle/${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Erreur validation :", error);
    throw error;
  }
};

  export const updateDeveloper = async ( accountId, data) => {
      try {
        const response = await api.put(`/developer-accounts/${accountId}`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const deleteDeveloper = async (id) => {
    try {
        const response = await api.delete(`/developer-accounts/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
  };
  
  export const validateBusiness = async ( id) => {
    try {
      const response = await api.put(`/developer-accounts/activate/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  };
  
  export const desactiveBusiness = async ( id,reason) => {
    try {
      const response = await api.put(`/developer-accounts/deactivate/${id}`,
        {
        reason
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getCompanyByCompanyId = async (companyId) => {
    try {
      const response = await api.get(`/developer-accounts/company/${companyId}`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const makeProdDeveloper = async (developerId) => {
    try {
      const response = await api.put(`/developer-accounts/${developerId}/switch-to-production`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const addSector = async (name) => {
    try {
      const response = await api.create(`/sector/create`, {name});
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getAllSector = async () => {
    try {
      const response = await api.get(`/sector/all`);
      return response;
    } catch (error) {
      throw error;
    }
  };

 // ✅ services/developerApi.js
export const getTurnOverByBusinessId = async (busId, year) => {
  try {
    const response = await api.get(`/developer-accounts/${busId}/revenues/${year}`);
    return response.data; // 🟢 on retourne directement les données utiles
  } catch (error) {
    throw error;
  }
};


  export const getMetricsByBusIdPercountryCode = async (busId, cc) => {
    try {
      const response = await api.get(`/developer-accounts/${busId}/country-balance/${cc}`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getAnnualTransfertByBusinessId = async (busId, year) => {
    try {
      const response = await api.get(`/developer-accounts/${busId}/transfers/${year}`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getTransStatByBusId = async (busId, month, year) => {
    try {
      const response = await api.get(`/developer-accounts/${busId}/transactionStats?month=${month}&year=${year}`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getMetricsByBusIdPerOperator = async (busId) => {
    try {
      const response = await api.get(`/developer-accounts/${busId}/transaction-category-count`);
      return response;
    } catch (error) {
      throw error;
    }
  };
export const getAllCountry = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_API_TRANSACTION+"/country/");
        return response;
      } catch (error) {
        throw error;
      }
  };
export const getVersementByBusiness = async (id) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_TRANSACTION}/manage/pay-out/business/${id}`);
    return response.data;
  } catch (error) {
    console.error("Erreur API:", error);
    throw error;
  }
};
export const getAllCountryPaymentMethod = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_API_TRANSACTION+"/payment-method/paxity");
        return response;
      } catch (error) {
        throw error;
      }
  };
export const getPaymentMethodByCountry = async (countryCode) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_TRANSACTION}/payment-method/country/${countryCode}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCardStatus = async (id, payload) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_URL}/admin/dashboard/${id}/payment-methods`,
      payload // ✅ DIRECTEMENT le body
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};
 export const updatePMStatus = async (payload) => {
  try {
    const response = await api.put(
      `/admin/dashboard/payment-methods/toggle`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Erreur updatePMStatus:", error.response?.data || error.message);
    throw error;
  }
};
export const getTransactionByBusiness = async (businessId) => {
  try {
    const currentuser = JSON.parse(sessionStorage.getItem("authAdmin"));
    const token = currentuser?.token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_TRANSACTION}/manage/pay-in/business`,
      {
        params: { business: businessId },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("🔴 API ERROR:", error?.response?.data || error);
    throw error;
  }
};
export const getPaymentLinkByBusiness = async (businessId) => {
  try {
    const currentuser = JSON.parse(sessionStorage.getItem("authAdmin"));
    const token = currentuser?.token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_TRANSACTION}/manage/payment-link/business`,
      {
        params: { business: businessId },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("🔴 API ERROR:", error?.response?.data || error);
    throw error;
  }
};
export const getPaymentLinkEdupaxByBusiness = async (
  businessId,
  apiKey,
  apiToken
) => {
  try {
    const currentuser = JSON.parse(sessionStorage.getItem("authAdmin"));
    const token = currentuser?.token;

    const response = await axios.get(
      `${process.env.REACT_APP_API_TRANSACTION}/schools/link`,
      {
        
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": apiKey,
          "x-api-token": apiToken,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("🔴 API ERROR:", error?.response?.data || error);
    throw error;
  }
};
export const getSummaryFeesEdupaxByBusiness = async (
  apiKey,
  apiToken,
  month 
) => {
  try {
    const currentuser = JSON.parse(sessionStorage.getItem("authAdmin"));
    const token = currentuser?.token;

    const response = await axios.get(
      `${process.env.REACT_APP_API_TRANSACTION}/schools/fees/summary`,
      {
        params: {
          month: month
        },
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": apiKey,
          "x-api-token": apiToken,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("🔴 API ERROR:", error?.response?.data || error);
    throw error;
  }
};
export const getAmountFrozen = async (merchantId,businessId) => {
  try {
    const currentuser = JSON.parse(sessionStorage.getItem("authAdmin"));
    const token = currentuser?.token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_TRANSACTION}/manage/pay-out/banks/frozen/merchant`,
      {
        params: { business: businessId,merchant:merchantId },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("🔴 API ERROR:", error?.response?.data || error);
    throw error;
  }
};
  export const addDocBusiness = async (files) => {
    const formData = new FormData();

    if (files.businessId) {
      formData.append("businessId", files.businessId);
    }
    if (files.merchantDocumentType) {
      formData.append("merchantDocumentType", files.merchantDocumentType);
    }
    if (files.merchantRecto) {
      formData.append("merchantRecto", files.merchantRecto);
    }
    if (files.merchantVerso) {
      formData.append("merchantVerso", files.merchantVerso);
    }
  
    if (files.businessRegistryFileName) {
      formData.append("businessRegistryFileName", files.businessRegistryFileName);
    }
    if (files.nineaFileName) {
      formData.append("nineaFileName", files.nineaFileName);
    }
    if (files.statutFileName) {
      formData.append("statutFileName", files.statutFileName);
    }
    if (files.RIB) {
      formData.append("RIB", files.RIB);
    }
    if (files.Domicile) {
      formData.append("Domicile", files.Domicile);
    }
    try {
      const response = await axios.post(`/developer-accounts/business-registry/${files?.id}`,
        formData,
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${files?.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("Réponse API :", response);

      return response;
    } catch (error) {
      console.error("Erreur upload :", error);
      throw error;
    }
  };
export const updateAmountFrozen = async (id, status) => {
  try {
    const token = JSON.parse(sessionStorage.getItem("authAdmin"))?.token;

    const response = await axios.put(
      `${process.env.REACT_APP_API_TRANSACTION}/manage/pay-out/banks/transactions/${id}/reversement-status`,
      null, 
      {
        params: {
          status,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("🔴 API ERROR:", error?.response?.data || error);
    throw error;
  }
};
export const configureRetention = async (devId, data) => {
  try {
    const response = await api.create(
      `/admin/holds/${devId}/configure`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getRechargeBankTransfer = async (
  apiKey,
  apiToken,
) => {
  try {
    const currentuser = JSON.parse(sessionStorage.getItem("authAdmin"));
    const token = currentuser?.token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_TRANSACTION}/transaction/recharge/bank-transfer/requests`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": apiKey,
          "x-api-token": apiToken,
        },
      }
    );
    return response
  } catch (error) {
    console.error("🔴 API ERROR:", error?.response?.data || error);
    throw error;
  }
};

export const ApprovedtransferBank = async (id, adminNote, apiKey,apiToken) => {
  try {
      const currentuser = JSON.parse(sessionStorage.getItem("authAdmin"));
      const token = currentuser?.token;
      const response = await axios.post(
      `${process.env.REACT_APP_API_TRANSACTION}/manage/recharge/bank-transfer/requests/${id}/approve`,
        {
        adminNote, 
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": apiKey,
          "x-api-token": apiToken,
        
      },
      }
    );
    return response.data;
  } catch (error) {
    console.error("🔴 API ERROR:", error?.response?.data || error);
    throw error;
  }
};
export const rejectTransferBank = async (
  id,
  body,
  apiKey,
  apiToken
) => {
  try {
    const currentuser = JSON.parse(
      sessionStorage.getItem("authAdmin")
    );

    const token = currentuser?.token;

    const response = await axios.post(
      `${process.env.REACT_APP_API_TRANSACTION}/manage/recharge/bank-transfer/requests/${id}/reject`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": apiKey,
          "x-api-token": apiToken,
        },
      }
    );

    return response.data;

  } catch (error) {

    console.error(
      "🔴 API ERROR:",
      error?.response?.data || error
    );

    throw error;
  }
};
export const getProofDocument = async (id, inline, apiKey, apiToken) => {
  const token = JSON.parse(sessionStorage.getItem("authAdmin"))?.token;

  const response = await axios.get(
    `${process.env.REACT_APP_API_TRANSACTION}/manage/recharge/bank-transfer/requests/${id}/proof?inline=${inline}`,
    {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": apiKey,
        "x-api-token": apiToken,
      },
    }
  );

  return response.data;
};